import React from 'react';
// import OrderInsightInfo from "../Admin/Order/OrderInsightInfo";
// import OrderInsightList from "../Admin/Order/OrderInsightList";

const OrderInsight = () => {
  return <>
    <div className='adminconsole-container'>
      {/* <OrderInsightInfo />
      <OrderInsightList /> */}
    </div>
  </>

}


export default OrderInsight;